import { searchChats, getChatSession } from '../AdminApp/Chats/chatSearchApi'
import { ChatSearchParams, ChatSearchResponse, ChatSessionDetail } from '../AdminApp/Chats/chatSearchModel'

export function searchChatHistory(params: ChatSearchParams): Promise<ChatSearchResponse> {
  return searchChats({ ...params, myChats: true })
}

export function getChatSessionDetail(sessionId: string): Promise<ChatSessionDetail> {
  return getChatSession(sessionId)
}
